import { c as _c } from "react/compiler-runtime";
import { IconCircleCheck } from "central-icons/IconCircleCheck";
import { m } from "motion/react";
import { slideBlurVariants, springTransitions } from "@/lib/animation-presets";
export function FeedbackSuccess() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex size-10 items-center justify-center rounded-full border border-green-500/10 bg-green-500/10"><IconCircleCheck className="size-6 text-green-500" mode="raw" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <m.div className="flex h-full flex-col items-center justify-center gap-2 will-change-transform" key="success" transition={springTransitions.slower} {...slideBlurVariants}>{t0}<div className="flex flex-col items-center justify-center"><span className="font-semibold text-fg">Feedback Sent</span><p className="text-fg-secondary text-sm">Thank you for improving oklch.fyi!</p></div></m.div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}